import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {
  makeStyles
} from "@material-ui/core/styles";

import AuthorizationList from "./Viewer";

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default function CustomizedDialogs(props) {
  const {
    open,
    setOpen,
    fileId
  } = props;
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        open={open}
        fullScreen
      >
        <DialogContent>
          <AuthorizationList
            fileId = {fileId}
          />
        </DialogContent>
        {handleClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </Dialog>
    </div>
  );
}
